import { render } from "./UiAuditInfo.vue?vue&type=template&id=53e10275&ts=true"
import script from "./UiAuditInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiAuditInfo.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiAuditInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e10275"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e10275', __exports__)) {
    api.reload('53e10275', __exports__)
  }
  
  module.hot.accept("./UiAuditInfo.vue?vue&type=template&id=53e10275&ts=true", () => {
    api.rerender('53e10275', render)
  })

}


export default __exports__